// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"NotFound_actionButton__fgvWJ","title":"NotFound_title__1siSv"};